import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_BLACK_HISTORY_LOGO = defineFcm('enable_black_history_logo')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'Page header',
		description: 'Replace the default logo with a "black history month" logo. Usually only enabled for US.',
		import: false,
	});
